// Listă completă de țări (nume în română, cod ISO pentru steag `fi fi-<iso>` și prefix telefonic),
// derivată din libphonenumber-js + Intl.DisplayNames('ro'). Valoarea salvată/trimisă la BE rămâne
// DOAR string-ul `phoneCode`.

import { isValidPhoneNumber, type CountryCode } from 'libphonenumber-js';

export interface IPhoneCountry {
	/** Nume țară în română (cu diacritice) — folosit pentru afișare + căutare. */
	name: string;
	/** Cod ISO 3166-1 alpha-2 (lowercase) — folosit pentru steag: `fi fi-ro`. */
	iso: string;
	/** Prefixul telefonic, ex. „+40" — ACEASTA e valoarea din formular. */
	phoneCode: string;
}

// Sortate alfabetic după numele românesc.
export const PHONE_COUNTRIES: IPhoneCountry[] = [
	{ name: 'Afganistan', iso: 'af', phoneCode: '+93' },
	{ name: 'Africa de Sud', iso: 'za', phoneCode: '+27' },
	{ name: 'Albania', iso: 'al', phoneCode: '+355' },
	{ name: 'Algeria', iso: 'dz', phoneCode: '+213' },
	{ name: 'Andorra', iso: 'ad', phoneCode: '+376' },
	{ name: 'Angola', iso: 'ao', phoneCode: '+244' },
	{ name: 'Anguilla', iso: 'ai', phoneCode: '+1' },
	{ name: 'Antigua și Barbuda', iso: 'ag', phoneCode: '+1' },
	{ name: 'Arabia Saudită', iso: 'sa', phoneCode: '+966' },
	{ name: 'Argentina', iso: 'ar', phoneCode: '+54' },
	{ name: 'Armenia', iso: 'am', phoneCode: '+374' },
	{ name: 'Aruba', iso: 'aw', phoneCode: '+297' },
	{ name: 'Australia', iso: 'au', phoneCode: '+61' },
	{ name: 'Austria', iso: 'at', phoneCode: '+43' },
	{ name: 'Azerbaidjan', iso: 'az', phoneCode: '+994' },
	{ name: 'Bahamas', iso: 'bs', phoneCode: '+1' },
	{ name: 'Bahrain', iso: 'bh', phoneCode: '+973' },
	{ name: 'Bangladesh', iso: 'bd', phoneCode: '+880' },
	{ name: 'Barbados', iso: 'bb', phoneCode: '+1' },
	{ name: 'Belarus', iso: 'by', phoneCode: '+375' },
	{ name: 'Belgia', iso: 'be', phoneCode: '+32' },
	{ name: 'Belize', iso: 'bz', phoneCode: '+501' },
	{ name: 'Benin', iso: 'bj', phoneCode: '+229' },
	{ name: 'Bermuda', iso: 'bm', phoneCode: '+1' },
	{ name: 'Bhutan', iso: 'bt', phoneCode: '+975' },
	{ name: 'Bolivia', iso: 'bo', phoneCode: '+591' },
	{ name: 'Bosnia și Herțegovina', iso: 'ba', phoneCode: '+387' },
	{ name: 'Botswana', iso: 'bw', phoneCode: '+267' },
	{ name: 'Brazilia', iso: 'br', phoneCode: '+55' },
	{ name: 'Brunei', iso: 'bn', phoneCode: '+673' },
	{ name: 'Bulgaria', iso: 'bg', phoneCode: '+359' },
	{ name: 'Burkina Faso', iso: 'bf', phoneCode: '+226' },
	{ name: 'Burundi', iso: 'bi', phoneCode: '+257' },
	{ name: 'Cambodgia', iso: 'kh', phoneCode: '+855' },
	{ name: 'Camerun', iso: 'cm', phoneCode: '+237' },
	{ name: 'Canada', iso: 'ca', phoneCode: '+1' },
	{ name: 'Capul Verde', iso: 'cv', phoneCode: '+238' },
	{ name: 'Cehia', iso: 'cz', phoneCode: '+420' },
	{ name: 'Chile', iso: 'cl', phoneCode: '+56' },
	{ name: 'China', iso: 'cn', phoneCode: '+86' },
	{ name: 'Ciad', iso: 'td', phoneCode: '+235' },
	{ name: 'Cipru', iso: 'cy', phoneCode: '+357' },
	{ name: 'Columbia', iso: 'co', phoneCode: '+57' },
	{ name: 'Comore', iso: 'km', phoneCode: '+269' },
	{ name: 'Congo - Brazzaville', iso: 'cg', phoneCode: '+242' },
	{ name: 'Congo - Kinshasa', iso: 'cd', phoneCode: '+243' },
	{ name: 'Coreea de Nord', iso: 'kp', phoneCode: '+850' },
	{ name: 'Coreea de Sud', iso: 'kr', phoneCode: '+82' },
	{ name: 'Costa Rica', iso: 'cr', phoneCode: '+506' },
	{ name: 'Côte d’Ivoire', iso: 'ci', phoneCode: '+225' },
	{ name: 'Croația', iso: 'hr', phoneCode: '+385' },
	{ name: 'Cuba', iso: 'cu', phoneCode: '+53' },
	{ name: 'Curaçao', iso: 'cw', phoneCode: '+599' },
	{ name: 'Danemarca', iso: 'dk', phoneCode: '+45' },
	{ name: 'Djibouti', iso: 'dj', phoneCode: '+253' },
	{ name: 'Dominica', iso: 'dm', phoneCode: '+1' },
	{ name: 'Ecuador', iso: 'ec', phoneCode: '+593' },
	{ name: 'Egipt', iso: 'eg', phoneCode: '+20' },
	{ name: 'El Salvador', iso: 'sv', phoneCode: '+503' },
	{ name: 'Elveția', iso: 'ch', phoneCode: '+41' },
	{ name: 'Emiratele Arabe Unite', iso: 'ae', phoneCode: '+971' },
	{ name: 'Eritreea', iso: 'er', phoneCode: '+291' },
	{ name: 'Estonia', iso: 'ee', phoneCode: '+372' },
	{ name: 'Eswatini', iso: 'sz', phoneCode: '+268' },
	{ name: 'Etiopia', iso: 'et', phoneCode: '+251' },
	{ name: 'Fiji', iso: 'fj', phoneCode: '+679' },
	{ name: 'Filipine', iso: 'ph', phoneCode: '+63' },
	{ name: 'Finlanda', iso: 'fi', phoneCode: '+358' },
	{ name: 'Franța', iso: 'fr', phoneCode: '+33' },
	{ name: 'Gabon', iso: 'ga', phoneCode: '+241' },
	{ name: 'Gambia', iso: 'gm', phoneCode: '+220' },
	{ name: 'Georgia', iso: 'ge', phoneCode: '+995' },
	{ name: 'Germania', iso: 'de', phoneCode: '+49' },
	{ name: 'Ghana', iso: 'gh', phoneCode: '+233' },
	{ name: 'Gibraltar', iso: 'gi', phoneCode: '+350' },
	{ name: 'Grecia', iso: 'gr', phoneCode: '+30' },
	{ name: 'Grenada', iso: 'gd', phoneCode: '+1' },
	{ name: 'Groenlanda', iso: 'gl', phoneCode: '+299' },
	{ name: 'Guadelupa', iso: 'gp', phoneCode: '+590' },
	{ name: 'Guam', iso: 'gu', phoneCode: '+1' },
	{ name: 'Guatemala', iso: 'gt', phoneCode: '+502' },
	{ name: 'Guernsey', iso: 'gg', phoneCode: '+44' },
	{ name: 'Guineea', iso: 'gn', phoneCode: '+224' },
	{ name: 'Guineea Ecuatorială', iso: 'gq', phoneCode: '+240' },
	{ name: 'Guineea-Bissau', iso: 'gw', phoneCode: '+245' },
	{ name: 'Guyana', iso: 'gy', phoneCode: '+592' },
	{ name: 'Guyana Franceză', iso: 'gf', phoneCode: '+594' },
	{ name: 'Haiti', iso: 'ht', phoneCode: '+509' },
	{ name: 'Honduras', iso: 'hn', phoneCode: '+504' },
	{ name: 'India', iso: 'in', phoneCode: '+91' },
	{ name: 'Indonezia', iso: 'id', phoneCode: '+62' },
	{ name: 'Insula Ascension', iso: 'ac', phoneCode: '+247' },
	{ name: 'Insula Christmas', iso: 'cx', phoneCode: '+61' },
	{ name: 'Insula Man', iso: 'im', phoneCode: '+44' },
	{ name: 'Insula Norfolk', iso: 'nf', phoneCode: '+672' },
	{ name: 'Insulele Åland', iso: 'ax', phoneCode: '+358' },
	{ name: 'Insulele Caraibe Olandeze', iso: 'bq', phoneCode: '+599' },
	{ name: 'Insulele Cayman', iso: 'ky', phoneCode: '+1' },
	{ name: 'Insulele Cocos (Keeling)', iso: 'cc', phoneCode: '+61' },
	{ name: 'Insulele Cook', iso: 'ck', phoneCode: '+682' },
	{ name: 'Insulele Falkland', iso: 'fk', phoneCode: '+500' },
	{ name: 'Insulele Feroe', iso: 'fo', phoneCode: '+298' },
	{ name: 'Insulele Mariane de Nord', iso: 'mp', phoneCode: '+1' },
	{ name: 'Insulele Marshall', iso: 'mh', phoneCode: '+692' },
	{ name: 'Insulele Solomon', iso: 'sb', phoneCode: '+677' },
	{ name: 'Insulele Turks și Caicos', iso: 'tc', phoneCode: '+1' },
	{ name: 'Insulele Virgine Americane', iso: 'vi', phoneCode: '+1' },
	{ name: 'Insulele Virgine Britanice', iso: 'vg', phoneCode: '+1' },
	{ name: 'Iordania', iso: 'jo', phoneCode: '+962' },
	{ name: 'Irak', iso: 'iq', phoneCode: '+964' },
	{ name: 'Iran', iso: 'ir', phoneCode: '+98' },
	{ name: 'Irlanda', iso: 'ie', phoneCode: '+353' },
	{ name: 'Islanda', iso: 'is', phoneCode: '+354' },
	{ name: 'Israel', iso: 'il', phoneCode: '+972' },
	{ name: 'Italia', iso: 'it', phoneCode: '+39' },
	{ name: 'Jamaica', iso: 'jm', phoneCode: '+1' },
	{ name: 'Japonia', iso: 'jp', phoneCode: '+81' },
	{ name: 'Jersey', iso: 'je', phoneCode: '+44' },
	{ name: 'Kazahstan', iso: 'kz', phoneCode: '+7' },
	{ name: 'Kârgâzstan', iso: 'kg', phoneCode: '+996' },
	{ name: 'Kenya', iso: 'ke', phoneCode: '+254' },
	{ name: 'Kiribati', iso: 'ki', phoneCode: '+686' },
	{ name: 'Kosovo', iso: 'xk', phoneCode: '+383' },
	{ name: 'Kuweit', iso: 'kw', phoneCode: '+965' },
	{ name: 'Laos', iso: 'la', phoneCode: '+856' },
	{ name: 'Lesotho', iso: 'ls', phoneCode: '+266' },
	{ name: 'Letonia', iso: 'lv', phoneCode: '+371' },
	{ name: 'Liban', iso: 'lb', phoneCode: '+961' },
	{ name: 'Liberia', iso: 'lr', phoneCode: '+231' },
	{ name: 'Libia', iso: 'ly', phoneCode: '+218' },
	{ name: 'Liechtenstein', iso: 'li', phoneCode: '+423' },
	{ name: 'Lituania', iso: 'lt', phoneCode: '+370' },
	{ name: 'Luxemburg', iso: 'lu', phoneCode: '+352' },
	{ name: 'Macedonia de Nord', iso: 'mk', phoneCode: '+389' },
	{ name: 'Madagascar', iso: 'mg', phoneCode: '+261' },
	{ name: 'Malawi', iso: 'mw', phoneCode: '+265' },
	{ name: 'Malaysia', iso: 'my', phoneCode: '+60' },
	{ name: 'Maldive', iso: 'mv', phoneCode: '+960' },
	{ name: 'Mali', iso: 'ml', phoneCode: '+223' },
	{ name: 'Malta', iso: 'mt', phoneCode: '+356' },
	{ name: 'Maroc', iso: 'ma', phoneCode: '+212' },
	{ name: 'Martinica', iso: 'mq', phoneCode: '+596' },
	{ name: 'Mauritania', iso: 'mr', phoneCode: '+222' },
	{ name: 'Mauritius', iso: 'mu', phoneCode: '+230' },
	{ name: 'Mayotte', iso: 'yt', phoneCode: '+262' },
	{ name: 'Mexic', iso: 'mx', phoneCode: '+52' },
	{ name: 'Micronezia', iso: 'fm', phoneCode: '+691' },
	{ name: 'Monaco', iso: 'mc', phoneCode: '+377' },
	{ name: 'Mongolia', iso: 'mn', phoneCode: '+976' },
	{ name: 'Montserrat', iso: 'ms', phoneCode: '+1' },
	{ name: 'Mozambic', iso: 'mz', phoneCode: '+258' },
	{ name: 'Muntenegru', iso: 'me', phoneCode: '+382' },
	{ name: 'Myanmar (Birmania)', iso: 'mm', phoneCode: '+95' },
	{ name: 'Namibia', iso: 'na', phoneCode: '+264' },
	{ name: 'Nauru', iso: 'nr', phoneCode: '+674' },
	{ name: 'Nepal', iso: 'np', phoneCode: '+977' },
	{ name: 'Nicaragua', iso: 'ni', phoneCode: '+505' },
	{ name: 'Niger', iso: 'ne', phoneCode: '+227' },
	{ name: 'Nigeria', iso: 'ng', phoneCode: '+234' },
	{ name: 'Niue', iso: 'nu', phoneCode: '+683' },
	{ name: 'Norvegia', iso: 'no', phoneCode: '+47' },
	{ name: 'Noua Caledonie', iso: 'nc', phoneCode: '+687' },
	{ name: 'Noua Zeelandă', iso: 'nz', phoneCode: '+64' },
	{ name: 'Oman', iso: 'om', phoneCode: '+968' },
	{ name: 'Pakistan', iso: 'pk', phoneCode: '+92' },
	{ name: 'Palau', iso: 'pw', phoneCode: '+680' },
	{ name: 'Panama', iso: 'pa', phoneCode: '+507' },
	{ name: 'Papua-Noua Guinee', iso: 'pg', phoneCode: '+675' },
	{ name: 'Paraguay', iso: 'py', phoneCode: '+595' },
	{ name: 'Peru', iso: 'pe', phoneCode: '+51' },
	{ name: 'Polinezia Franceză', iso: 'pf', phoneCode: '+689' },
	{ name: 'Polonia', iso: 'pl', phoneCode: '+48' },
	{ name: 'Portugalia', iso: 'pt', phoneCode: '+351' },
	{ name: 'Puerto Rico', iso: 'pr', phoneCode: '+1' },
	{ name: 'Qatar', iso: 'qa', phoneCode: '+974' },
	{ name: 'R.A.S. Hong Kong, China', iso: 'hk', phoneCode: '+852' },
	{ name: 'R.A.S. Macao, China', iso: 'mo', phoneCode: '+853' },
	{ name: 'Regatul Unit', iso: 'gb', phoneCode: '+44' },
	{ name: 'Republica Centrafricană', iso: 'cf', phoneCode: '+236' },
	{ name: 'Republica Dominicană', iso: 'do', phoneCode: '+1' },
	{ name: 'Republica Moldova', iso: 'md', phoneCode: '+373' },
	{ name: 'Réunion', iso: 're', phoneCode: '+262' },
	{ name: 'România', iso: 'ro', phoneCode: '+40' },
	{ name: 'Rusia', iso: 'ru', phoneCode: '+7' },
	{ name: 'Rwanda', iso: 'rw', phoneCode: '+250' },
	{ name: 'Sahara Occidentală', iso: 'eh', phoneCode: '+212' },
	{ name: 'Saint Kitts și Nevis', iso: 'kn', phoneCode: '+1' },
	{ name: 'Saint Vincent și Grenadinele', iso: 'vc', phoneCode: '+1' },
	{ name: 'Saint-Barthélemy', iso: 'bl', phoneCode: '+590' },
	{ name: 'Saint-Pierre și Miquelon', iso: 'pm', phoneCode: '+508' },
	{ name: 'Samoa', iso: 'ws', phoneCode: '+685' },
	{ name: 'Samoa Americană', iso: 'as', phoneCode: '+1' },
	{ name: 'San Marino', iso: 'sm', phoneCode: '+378' },
	{ name: 'São Tomé și Príncipe', iso: 'st', phoneCode: '+239' },
	{ name: 'Senegal', iso: 'sn', phoneCode: '+221' },
	{ name: 'Serbia', iso: 'rs', phoneCode: '+381' },
	{ name: 'Seychelles', iso: 'sc', phoneCode: '+248' },
	{ name: 'Sfânta Elena', iso: 'sh', phoneCode: '+290' },
	{ name: 'Sfânta Lucia', iso: 'lc', phoneCode: '+1' },
	{ name: 'Sfântul Martin', iso: 'mf', phoneCode: '+590' },
	{ name: 'Sierra Leone', iso: 'sl', phoneCode: '+232' },
	{ name: 'Singapore', iso: 'sg', phoneCode: '+65' },
	{ name: 'Sint-Maarten', iso: 'sx', phoneCode: '+1' },
	{ name: 'Siria', iso: 'sy', phoneCode: '+963' },
	{ name: 'Slovacia', iso: 'sk', phoneCode: '+421' },
	{ name: 'Slovenia', iso: 'si', phoneCode: '+386' },
	{ name: 'Somalia', iso: 'so', phoneCode: '+252' },
	{ name: 'Spania', iso: 'es', phoneCode: '+34' },
	{ name: 'Sri Lanka', iso: 'lk', phoneCode: '+94' },
	{ name: 'Statele Unite ale Americii', iso: 'us', phoneCode: '+1' },
	{ name: 'Statul Cetății Vaticanului', iso: 'va', phoneCode: '+39' },
	{ name: 'Sudan', iso: 'sd', phoneCode: '+249' },
	{ name: 'Sudanul de Sud', iso: 'ss', phoneCode: '+211' },
	{ name: 'Suedia', iso: 'se', phoneCode: '+46' },
	{ name: 'Suriname', iso: 'sr', phoneCode: '+597' },
	{ name: 'Svalbard și Jan Mayen', iso: 'sj', phoneCode: '+47' },
	{ name: 'Tadjikistan', iso: 'tj', phoneCode: '+992' },
	{ name: 'Taiwan', iso: 'tw', phoneCode: '+886' },
	{ name: 'Tanzania', iso: 'tz', phoneCode: '+255' },
	{ name: 'Teritoriile Palestiniene', iso: 'ps', phoneCode: '+970' },
	{ name: 'Teritoriul Britanic din Oceanul Indian', iso: 'io', phoneCode: '+246' },
	{ name: 'Thailanda', iso: 'th', phoneCode: '+66' },
	{ name: 'Timor-Leste', iso: 'tl', phoneCode: '+670' },
	{ name: 'Togo', iso: 'tg', phoneCode: '+228' },
	{ name: 'Tokelau', iso: 'tk', phoneCode: '+690' },
	{ name: 'Tonga', iso: 'to', phoneCode: '+676' },
	{ name: 'Trinidad și Tobago', iso: 'tt', phoneCode: '+1' },
	{ name: 'Tristan da Cunha', iso: 'ta', phoneCode: '+290' },
	{ name: 'Tunisia', iso: 'tn', phoneCode: '+216' },
	{ name: 'Turcia', iso: 'tr', phoneCode: '+90' },
	{ name: 'Turkmenistan', iso: 'tm', phoneCode: '+993' },
	{ name: 'Tuvalu', iso: 'tv', phoneCode: '+688' },
	{ name: 'Țările de Jos', iso: 'nl', phoneCode: '+31' },
	{ name: 'Ucraina', iso: 'ua', phoneCode: '+380' },
	{ name: 'Uganda', iso: 'ug', phoneCode: '+256' },
	{ name: 'Ungaria', iso: 'hu', phoneCode: '+36' },
	{ name: 'Uruguay', iso: 'uy', phoneCode: '+598' },
	{ name: 'Uzbekistan', iso: 'uz', phoneCode: '+998' },
	{ name: 'Vanuatu', iso: 'vu', phoneCode: '+678' },
	{ name: 'Venezuela', iso: 've', phoneCode: '+58' },
	{ name: 'Vietnam', iso: 'vn', phoneCode: '+84' },
	{ name: 'Wallis și Futuna', iso: 'wf', phoneCode: '+681' },
	{ name: 'Yemen', iso: 'ye', phoneCode: '+967' },
	{ name: 'Zambia', iso: 'zm', phoneCode: '+260' },
	{ name: 'Zimbabwe', iso: 'zw', phoneCode: '+263' }
];

// Rezolvă o țară după prefix. Mai multe țări pot împărți același prefix (ex. +1);
// întoarcem prima potrivire, suficient pentru afișare.
export const phoneCountryByCode = (code?: string | null): IPhoneCountry | undefined => {
	if (!code) return undefined;
	const normalized = code.trim();
	return PHONE_COUNTRIES.find((country) => country.phoneCode === normalized);
};

const isoByPhoneCode = (code?: string | null): CountryCode | undefined => {
	const iso = phoneCountryByCode(code)?.iso;
	return iso ? (iso.toUpperCase() as CountryCode) : undefined;
};

// Validare per-țară a numărului național (fără prefix), pe baza prefixului selectat.
// Pentru prefixe necunoscute (valori custom) cădem pe o verificare generică de lungime.
export const isValidNationalPhone = (
	phoneCode?: string | null,
	phone?: string | null
): boolean => {
	const digits = (phone ?? '').replace(/\D/g, '');
	if (!digits) return false;
	const iso = isoByPhoneCode(phoneCode);
	if (!iso) return /^[0-9]{6,15}$/.test(digits);
	return isValidPhoneNumber(digits, iso);
};
